<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-horizontal-padding orangehrm-vertical-padding">
    <oxd-text tag="h6" class="orangehrm-main-title">
      Add Salary Revision
    </oxd-text>
    <oxd-divider />
    <oxd-form :loading="isLoading" @submit-valid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="3" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.basic_salary"
              label="Basic"
              :rules="rules.basic_salary"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.hra"
              label="HRA"
              :rules="rules.hra"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.conveyance_allowance"
              label="Conveyance Allowance"
              :rules="rules.conveyance_allowance"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.communication_allowance"
              label="Communication Allowance"
              :rules="rules.communication_allowance"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.special_allowance"
              label="Special Allowance"
              :rules="rules.special_allowance"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.total_earnings"
              label="Total Earnings"
              :rules="rules.total_earnings"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.provident_fund"
              label="Provident Fund (If applicable)"
              :rules="rules.provident_fund"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              :key="currenciesOpts"
              v-model="salaryComponent.currencyId"
              type="select"
              :label="$t('general.currency')"
              :options="currenciesOpts"
              :rules="rules.currencyId"
              required
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <oxd-form-actions>
        <required-text />
        <oxd-button
          type="button"
          display-type="ghost"
          :label="$t('general.cancel')"
          @click="onCancel"
        />
        <submit-button />
      </oxd-form-actions>
    </oxd-form>
  </div>
  <oxd-divider />
</template>

<script>
import {
  digitsOnlyWithDecimalPoint,
  required,
} from '@ohrm/core/util/validation/rules';

const salComponentModel = {
  basic_salary: '',
  hra: '',
  conveyance_allowance: '',
  communication_allowance: '',
  special_allowance: '',
  total_earnings: '',
  provident_fund: '',
  currencyId: null,
};

export default {
  name: 'SaveSalaryComponent',
  props: {
    http: {
      type: Object,
      required: true,
    },
    paygrades: {
      type: Array,
      default: () => [],
    },
    payFrequencies: {
      type: Array,
      default: () => [],
    },
    currencies: {
      type: Array,
      default: () => [],
    },
    accountTypes: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['close'],

  data() {
    return {
      isLoading: false,
      salaryComponent: {...salComponentModel},
      usableCurrencies: [],
      rules: {
        basic_salary: [required, digitsOnlyWithDecimalPoint],
        hra: [digitsOnlyWithDecimalPoint],
        conveyance_allowance: [required, digitsOnlyWithDecimalPoint],
        communication_allowance: [required, digitsOnlyWithDecimalPoint],
        special_allowance: [required, digitsOnlyWithDecimalPoint],
        total_earnings: [required, digitsOnlyWithDecimalPoint],
        provident_fund: [digitsOnlyWithDecimalPoint],
        currencyId: [required],
      },
    };
  },

  computed: {
    currenciesOpts() {
      return this.currencies;
    },
    currencyInfo() {
      return this.usableCurrencies.find(
        (item) => item.id === this.salaryComponent.currencyId?.id,
      );
    },
  },

  methods: {
    onSave() {
      this.isLoading = true;
      this.http
        .create({
          // Paygrade fields
          basic_salary: this.salaryComponent.basic_salary,
          hra: this.salaryComponent.hra,
          conveyance_allowance: this.salaryComponent.conveyance_allowance,
          communication_allowance: this.salaryComponent.communication_allowance,
          special_allowance: this.salaryComponent.special_allowance,
          total_earnings: this.salaryComponent.total_earnings,
          provident_fund: this.salaryComponent.provident_fund,
          currencyId: this.salaryComponent.currencyId?.id,
        })
        .then(() => {
          return this.$toast.saveSuccess();
        })
        .then(() => {
          this.onCancel();
        });
    },
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.directdeposit-form-header {
  display: flex;
  padding: 1rem;
  &-text {
    font-size: 0.8rem;
    margin-right: 1rem;
  }
}
</style>
